<template>
  <button ref="button" type="submit"
          :disabled="buttonDisabled"
          class="btn btn-primary"
          @click.prevent="$emit('click', $event)">
    <!-- Q: Why set type=submit if we're going to prevent the default behavior of submitting the form?
         A: Having a submit button at all changes the form behavior by enabling "Enter to submit" on text fields -->
    {{ buttonText }}
  </button>
</template>

<script>
import { inject } from 'vue'
import PrimaryButton from './primary-button'

export default {
  extends: PrimaryButton,

  props: {
    formValid: {
      type: Boolean,
      required: false,
      default: true
    },

    submitInProgress: {
      type: Boolean,
      required: false,
      default: false
    },

    submittingLabel: {
      type: String,
      required: false,
      default: function() { return inject('i18n').t('submitting') }
    }
  },

  emits: ['click'],

  computed: {
    buttonDisabled() {
      return !this.formValid || this.submitInProgress
    },

    buttonText() {
      if (this.submitInProgress) {
        return this.submittingLabel
      } else {
        return this.label
      }
    }
  },

  methods: {
    click() {
      this.$refs.button.click()
    },

    focus() {
      this.$refs.button.focus()
    }
  }
}
</script>
